import { AppContextState } from "src/AppContextProvider";

/**
 * Gates the /groups and /groups/roles routes.
 * Mirrors AdminNav's "Groups & Roles" tab visibility:
 * group:read AND at least one group mutate ability.
 * Viewers (read-only with no group abilities) are rejected,
 * closing pentest finding GRWBKK-1397 / PENTEST-138 / 3.3.5.
 */
export const canAccessGroupsRoute = (context: AppContextState): boolean => {
  const p = context.currentPermissions;
  return (
    p.validateOrg("group", "read") &&
    (p.validateOrg("group", "create") ||
      p.validateOrg("group", "delete") ||
      p.validateOrg("group", "update") ||
      p.validateOrg("group", "permissions") ||
      p.validateOrg("group", "members"))
  );
};
